'use es6';

import { Component } from 'react';
import PropTypes from 'prop-types';
import { setDefaultNode as setDefaultNodeDeprecated } from 'UIComponents/utils/RootNode';
import { setDefaultNode } from 'foundations-components/transitional/utils/RootNode';
import SharedDragDropContext from 'InpageEditorUI/lib/DragDropContext';
import { InpageModes } from 'ContentEditorUI/lib/app/constants';
import ClickCatcher from 'InpageEditorUI/components/ClickCatcher';
import { isPreviewOnly } from 'InpageEditorUI/lib/urlUtils';
import { NAMESPACE_CLASS } from 'ContentEditorUI/lib/inpage/Constants';
import XRayPageCrawlerContainer from './xray/XRayPageCrawlerContainer';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
class InpageRoot extends Component {
  componentDidMount() {
    setDefaultNodeDeprecated(this.uiComponentRoot);
    setDefaultNode(this.uiComponentRoot);
  }
  clickCatcherCallback() {
    const {
      onResetInpageMode
    } = this.props;
    onResetInpageMode();
  }
  renderEditControllerDOM() {
    return /*#__PURE__*/_jsx("div", {
      className: "hs-overlay-component"
    });
  }
  renderLayoutModeClickCatcher() {
    const {
      currentInpageMode
    } = this.props;
    return /*#__PURE__*/_jsx("div", {
      className: "hs-click-catcher-component",
      children: currentInpageMode === InpageModes.LAYOUT && /*#__PURE__*/_jsx(ClickCatcher, {
        onClickCallback: () => this.clickCatcherCallback()
      })
    });
  }
  renderToolbarContainer() {
    return /*#__PURE__*/_jsx("div", {
      className: "hs-tinymce-toolbar-component",
      id: "tinymce-toolbar"
    });
  }
  renderUIComponentRoot() {
    const className = `${NAMESPACE_CLASS} mce-root-node`;
    return /*#__PURE__*/_jsx("div", {
      ref: node => this.uiComponentRoot = node,
      className: className,
      style: {
        position: 'static !important'
      }
    });
  }
  mountXrayPageCrawler() {
    return /*#__PURE__*/_jsx(XRayPageCrawlerContainer, {});
  }
  render() {
    if (isPreviewOnly()) {
      return null;
    }
    return /*#__PURE__*/_jsxs("div", {
      children: [this.renderToolbarContainer(), this.renderUIComponentRoot(), this.renderEditControllerDOM(), this.renderLayoutModeClickCatcher(), this.mountXrayPageCrawler(), this.props.children]
    });
  }
}
InpageRoot.propTypes = {
  currentInpageMode: PropTypes.string.isRequired,
  children: PropTypes.node,
  onResetInpageMode: PropTypes.func.isRequired
};
export default SharedDragDropContext(InpageRoot);